import { Component, Input } from "@angular/core";

@Component({
  selector: "discussion-feed-tags",
  templateUrl: "./discussion-feed-tags.component.html",
  styleUrls: [
    "./discussion-feed-tags.component.scss",
    "../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class DiscussionFeedTagsComponent {
  constructor() {}
  @Input() tag: string;
}
